import { render, staticRenderFns } from "./PublicationCard.vue?vue&type=template&id=3b0acbc2"
import script from "./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue?vue&type=script&lang=js"
import style0 from "./PublicationCard.vue?vue&type=style&index=0&id=3b0acbc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports